/**
 * /* eslint-disable react-hooks/exhaustive-deps
 *
 * @format
 */

/** @format */

// material
import {
  Box,
  Grid,
  Container,
  Typography,
  Stack,
  Tabs,
  Tab,
} from '@mui/material';
// components
import Page from '../../components/Page';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import Statistic from '../../dao/Statistic';
import MessagesChart from './MessagesChart';
// import TotalBalance from "./TotalBalance";
import CardDashboard from './CardDashboard';
import Waba from '../../dao/Waba';
import Select from 'react-select';
import qs from 'qs';
import moment from 'moment';
import { useLocation } from 'react-router-dom';

import _ from 'lodash';
import MessagesChart2 from './MessagesChart2';
import MessagesChartBroadcast from './MessagesChartBroadcast';
import PhoneNumber from '../../dao/PhoneNumber';
import Broadcast from '../../dao/Broadcast';
import swal from '../../reusables/CustomSwal';
import { useSelector } from 'react-redux';
import { wabaSetStatus } from '../../store/actions';
import { blacklistUser } from '../../static/blacklist';
import DateRangeSelectDialog from '../../components/DateRangeSelectDialog';
import PendingDashboard from './PendingDashboard';
import textFormatter from '../../utils/TextFormatter';

// ----------------------------------------------------------------------

const dateRangeOptions = [
  {
    label: '1 Day',
    value: '1day',
    getDateStart: function () {
      return moment().subtract(1, 'day').toDate().getTime();
    },
    getDateEnd: function () {
      return new Date().getTime();
    },
    granularity: 'HALF_HOUR',
  },
  {
    label: '1 Week',
    value: '1week',
    getDateStart: function () {
      return moment().subtract(1, 'week').toDate().getTime();
    },
    getDateEnd: function () {
      return new Date().getTime();
    },
    granularity: 'DAY',
  },
  {
    label: '30 Days',
    value: '1month',
    getDateStart: function () {
      return moment().subtract(1, 'month').toDate().getTime();
    },
    getDateEnd: function () {
      return new Date().getTime();
    },
    granularity: 'DAY',
  },
  {
    label: '6 Month',
    value: '6month',
    getDateStart: function () {
      return moment().subtract(6, 'month').toDate().getTime();
    },
    getDateEnd: function () {
      return new Date().getTime();
    },
    granularity: 'MONTH',
  },
];

export default function Dashboard() {
  // console.log('money', money(1000).from('USD').to('EUR'));
  // eslint-disable-next-line no-undef
  const dispatch = useDispatch();
  // let auth = useSelector(({ auth }) => auth?.auth);
  let status = useSelector(({ waba }) => waba?.waba);
  let email = useSelector(({ auth }) => auth?.auth?.email);

  const [isSelectingDate, setIsSelectingDate] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
  let idParam = queryParams.waba_id;

  const [startDate, setStartDate] = useState(new Date(Date.now() - 86400000));
  const [endDate, setEndDate] = useState(new Date());

  // eslint-disable-next-line no-unused-vars
  const [dateRangeDate, setDateRangeDate] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  });

  const [labels, setLabels] = useState([]);
  const [values, setValues] = useState([]);

  const [sentTotal, setSentTotal] = useState(0);
  const [deliveredTotal, setDeliveredTotal] = useState(0);
  // const [readTotal, setReadTotal] = useState(0);

  const [uiTotal, setUITotal] = useState(0);
  // const [_, setBITotal] = useState(0);

  const [biMarketing, setBiMarketing] = useState(0);
  const [biUtility, setBiUtility] = useState(0);
  const [biAuthentication, setBiAuthentication] = useState(0);

  const [conversationLabels, setConversationLabels] = useState([]);
  const [conversationValues, setConversationValues] = useState([]);

  const [broadcastLabels, setBroadcastLabels] = useState([]);
  const [broadcastValues, setBroadcastValues] = useState([]);

  const [broadcastSent, setBroadcastSent] = useState(0);
  const [broadcastRead, setBroadcastRead] = useState(0);
  const [broadcastDelivered, setBroadcastDelivered] = useState(0);
  const [wabaOptions, setWabaOptions] = useState([]);
  const [selectedWabaId, setSelectedWabaId] = useState(null);
  const [selectedWabaLabel, setSelectedWabaLabel] = useState(null);
  const [cost, setCost] = useState(null);

  // const [selectedDateFilter, setSelectedDateFilter] = useState(
  //   dateRangeOptions[0]
  // );

  const [selectedDateFilter] = useState(dateRangeOptions[0]);

  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState({});

  const [tab, setTab] = useState(0);

  // const checkBlaclistUser = () => {
  //   let check = blacklistUser.some((item) => item === email);
  //   console.log("CHECK HERE");
  //   console.log(check);
  //   return check;
  // };

  useEffect(() => {
    getWabas();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getWabas = async () => {
    try {
      let result = await Waba.getMyWaba();
      // const test = await User.getCurrency();
      // console.log('test', test);
      // console.log("MW", result);
      if (result.length !== 0) {
        //let templates = result.map((el) => ({...el.profile, role: el.role}));

        let formatted = result.map((obj) => {
          return {
            label: `${obj.name} (${obj.waba_id})`,
            value: obj.waba_id,
          };
        });

        if (formatted.length > 0) {
          let wabaFromParam = formatted.find((obj) => obj.value === idParam);

          if (wabaFromParam && idParam) {
            setSelectedWabaId(wabaFromParam.value);
            setSelectedWabaLabel(wabaFromParam.label);
          } else {
            setSelectedWabaId(formatted[0].value);
            setSelectedWabaLabel(formatted[0].label);
          }
        }

        setWabaOptions(formatted);
        dispatch(wabaSetStatus({ status: '' }));
      } else {
        dispatch(wabaSetStatus({ status: 'PENDING' }));
        navigate('/connectWFB');
        // let popupResult = await swal.fire({
        //   title: "Confirm",
        //   text: `Hai ${auth?.name}
        //   You don't have the Whatsapp Business API yet, please register for Facebook Business`,
        //   icon: "info",
        //   showConfirmButton: true,
        //   showCancelButton: true,
        //   confirmButtonText: "Save",
        // });

        // if (popupResult.isConfirmed) {
        //   navigate("/connectWFB");
        // }
      }
    } catch (e) {
      // nothing
    }
  };

  const fetchStatistic = async () => {
    try {
      setSentTotal(0);
      setDeliveredTotal(0);
      // setReadTotal(0);

      setLabels([]);
      setValues([]);

      let formattedStartDate = new moment(startDate).set({
        hour: 0,
        second: 0,
      });
      let formattedEndDate = new moment(endDate).set({ hour: 23, second: 59 });

      let granularity = 'HALF_HOUR';

      if (Math.abs(formattedStartDate.diff(formattedEndDate, 'Day')) > 2) {
        granularity = 'DAY';
      }

      if (Math.abs(formattedStartDate.diff(formattedEndDate, 'Day')) > 60) {
        granularity = 'MONTH';
      }

      let result = await Statistic.getWabaStatistic(
        selectedWabaId,
        formattedStartDate.toDate(),
        formattedEndDate.toDate(),
        granularity,
        selectedPhoneNumber?.value ? selectedPhoneNumber.value : null
      );
      // console.log("STATS", result);

      // let labels = [];
      // let values = [];

      const convertToDate = (param) => {
        let momentDate = moment(param.start * 1000);
        momentDate.set({ hour: 10, minute: 0 });
        return momentDate.format('DD MMM YYYY');
      };

      let sentTotal = 0;
      let deliveredTotal = 0;
      // let randomTotal = 0;

      let groupedMessageData = _.groupBy(result.data_points, convertToDate);

      // console.log(groupedMessageData);
      let valuesData = [];
      let labelsData = [];

      for (let rawDate of Object.keys(groupedMessageData)) {
        let sentTotalChange = 0;
        let deliveredTotalChange = 0;
        // let randomTotalChange = 0;
        let dayData = groupedMessageData[rawDate];

        labelsData.push(rawDate);
        for (let datum of dayData) {
          // randomTotalChange = Math.floor(Math.random() * datum.sent);
          sentTotalChange += datum.sent;
          deliveredTotalChange += datum.delivered;

          sentTotal += datum.sent;
          deliveredTotal += datum.delivered;
          // randomTotalChange = Math.floor(Math.random() * datum.sent);
          // randomTotalChange += datum.read;
        }

        valuesData.push({
          sent: sentTotalChange,
          delivered: deliveredTotalChange,
          // read: randomTotalChange,
        });
        sentTotalChange = 0;
        deliveredTotalChange = 0;
        // randomTotalChange = 0;
      }

      setSentTotal(sentTotal);
      setDeliveredTotal(deliveredTotal);

      setLabels(labelsData);
      setValues(valuesData);
    } catch (e) {
      console.log('ERR', e);
    }
  };

  const fetchConversationStatistic = async () => {
    try {
      setConversationLabels([]);
      setConversationValues([]);

      let formattedStartDate = new moment(startDate).set({
        hour: 0,
        second: 0,
      });
      let formattedEndDate = new moment(endDate).set({ hour: 23, second: 59 });

      let granularity = 'HALF_HOUR';

      if (Math.abs(formattedStartDate.diff(formattedEndDate, 'Day')) > 2) {
        granularity = 'DAY';
      }

      if (Math.abs(formattedStartDate.diff(formattedEndDate, 'Day')) > 60) {
        granularity = 'MONTH';
      }

      let result = await Statistic.getWabaConversationStatistic(
        selectedWabaId,
        formattedStartDate.toDate(),
        formattedEndDate.toDate(),
        granularity,
        selectedPhoneNumber?.value ? selectedPhoneNumber.value : null
      );


      let conversationLabels = [];
      let conversationValues = [];

      let data = result.data[0].data_points;
      let sortedData = _.sortBy(data, 'start', 'ASC');
      const convertToDate = (param) => {
        let momentDate = moment(param.start * 1000);
        momentDate.set({ hour: 10, minute: 0 });
        return momentDate.format('DD MMM YYYY');
      };

      let groupedData = _.groupBy(sortedData, convertToDate);

      let uiTotal = result.user;
      let biTotalMarketing = result['cost business marketing'];
      let biTotalAuthentication = result['cost business authentication'];
      let biTotalUtility = result['cost business utility'];


      for (let dateStart of Object.keys(groupedData)) {
        let toPush = result
        conversationLabels.push(dateStart);
        conversationValues.push(toPush);
      }

      setConversationLabels(conversationLabels);
      setConversationValues(conversationValues);
      setBiAuthentication(biTotalAuthentication);
      setBiMarketing(biTotalMarketing);
      setBiUtility(biTotalUtility);
      setUITotal(uiTotal);
    } catch (e) {
      console.log('ERR', e);
    }
  };

  const fetchBroadcast = async () => {
    try {
      let formattedStartDate = moment(startDate)
        .startOf('day')
        .format('YYYY-MM-DD');

      let formattedEndDate = moment(endDate)
        .startOf('day')
        .format('YYYY-MM-DD');

      let result = await Broadcast.getBroadcastDashboard(
        selectedWabaId,
        formattedStartDate,
        formattedEndDate,
        selectedPhoneNumber?.value ? selectedPhoneNumber.value : null
      );

      let broadcastLabels = [];
      let broadcastValues = [];

      let data = result.data;
      let sortedData = _.sortBy(data, 'start', 'ASC');
      const convertToDate = (param) => {
        return param.date;
      };

      let groupedData = _.groupBy(sortedData, convertToDate);

      let totalRead = 0;
      let totalSend = 0;
      let totalDelivered = 0;

      for (let dateStart of Object.keys(groupedData)) {
        let toPush = {
          'total read': 0,
          'total sent': 0,
          'total delivered': 0,
        };
        broadcastLabels.push(dateStart);
        let dataInGroup = groupedData[dateStart];
        for (let obj of dataInGroup) {
          toPush['total sent'] = toPush['total sent'] + obj.total_sent;
          toPush['total read'] = toPush['total read'] + obj.total_read;
          toPush['total delivered'] =
            toPush['total delivered'] + obj.total_delivered;
        }
        totalRead += toPush['total read'];
        totalSend += toPush['total sent'];
        totalDelivered += toPush['total delivered'];

        broadcastValues.push(toPush);
      }

      setBroadcastLabels(broadcastLabels);
      setBroadcastValues(broadcastValues);
      setBroadcastSent(totalSend);
      setBroadcastRead(totalRead);
      setBroadcastDelivered(totalDelivered);
      setUITotal(uiTotal);
    } catch (e) {
      console.log('ERR', e);
    }
  };

  const getPhoneNumbers = async () => {
    try {
      let result = await PhoneNumber.getAll(selectedWabaId);
      // console.log("PN", result);

      let formatted = result.map((obj) => {
        return {
          label: `${obj.display_phone_number}`,
          value: obj.display_phone_number.replace(/[^\d]/g, ''),
        };
      });

      // console.log("FM", formatted);
      setSelectedPhoneNumber(formatted[0]);
      setPhoneNumbers([...formatted]);
    } catch (e) {
      console.log('ERROR', e);
      await swal.fire({
        title: 'Error',
        text: 'An error has occurred. Please try again later.',
        icon: 'error',
      });
    }
  };

  const getCost = async () => {
    try {
      let result = await Waba.getCost(selectedPhoneNumber.value);
      if (result.length !== 0) {
        setCost({
          cost_business_authentication: result[0].cost_business_authentication,
          cost_business_marketing: result[0].cost_business_marketing,
          cost_business_utility: result[0].cost_business_utility,
          cost_user: result[0].cost_user,
        });
      } else {
        setCost({
          cost_business_authentication: 0,
          cost_business_marketing: 0,
          cost_business_utility: 0,
          cost_user: 0,
        });
      }
    } catch (e) {
      console.log('ERROR', e);
      await swal.fire({
        title: 'Error',
        text: 'An error has occurred. Please try again later.',
        icon: 'error',
      });
    }
  };

  useEffect(() => {
    if (selectedWabaId && selectedPhoneNumber?.value) {
      fetchStatistic();
      fetchConversationStatistic();
      fetchBroadcast();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedWabaId, startDate, endDate, selectedPhoneNumber]);

  useEffect(() => {
    if (selectedWabaId) {
      getPhoneNumbers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedWabaId]);

  useEffect(() => {
    if (selectedPhoneNumber?.value) getCost();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPhoneNumber]);

  // console.log("selectedPhoneNumber", selectedPhoneNumber);

  const showCost = (
    cost,
    uiTotal,
    biTotalUtility,
    biTotalAuthentication,
    biTotalMarketing
  ) => {
    if (cost !== null) {
      return textFormatter.moneyFormatter(
        uiTotal * cost?.cost_user +
          biTotalUtility * cost?.cost_business_utility +
          biTotalAuthentication * cost?.cost_business_authentication +
          biTotalMarketing * cost?.cost_business_marketing
      );
    } else {
      return textFormatter.moneyFormatter(0);
    }
  };
  const DashboardNotPending = () => {
    return (
      <>
        {tab === 0 ? (
          <Page title="Dashboard">
            <Container maxWidth="xl">
              <Box sx={{ marginTop: 5, marginBottom: 5, width: '100%' }}>
                <Tabs value={tab}>
                  <Tab
                    label="Conversation"
                    onClick={() => {
                      setTab(0);
                    }}
                  />
                  {!blacklistUser.some((item) => item === email) && (
                    <Tab
                      label="Broadcast"
                      onClick={() => {
                        setTab(1);
                      }}
                    />
                  )}
                </Tabs>
              </Box>
              <Box sx={{ pb: 5 }}>
                <Typography variant="h4">Analytics</Typography>
              </Box>
              <Grid container spacing={3}>
                <Grid item md={4}>
                  <Stack
                    style={{
                      marginBottom: 20,
                    }}
                    direction="column"
                  >
                    <small>Select by Waba ID :</small>
                    <div style={{ width: '100%' }}>
                      <Select
                        onChange={(option) => {
                          setSelectedWabaId(option.value);
                          setSelectedWabaLabel(option.label);
                        }}
                        value={{
                          label: selectedWabaLabel,
                          value: selectedWabaId,
                        }}
                        options={wabaOptions}
                      />
                    </div>
                  </Stack>
                </Grid>

                <Grid item md={4}>
                  <Stack
                    style={{
                      marginBottom: 20,
                    }}
                    direction="column"
                  >
                    <small>Select Phone Number :</small>
                    <div style={{ width: '100%' }}>
                      <Select
                        onChange={(option) => {
                          setSelectedPhoneNumber(option);
                        }}
                        value={selectedPhoneNumber}
                        options={phoneNumbers}
                      />
                    </div>
                  </Stack>
                </Grid>

                <Grid item md={4}>
                  <Stack
                    style={{
                      marginBottom: 20,
                    }}
                    direction="column"
                  >
                    <small>Select time Range :</small>
                    <div style={{ width: '100%' }}>
                      <Select
                        onMenuOpen={() => {
                          setIsSelectingDate(true);
                          setDateRangeDate({
                            startDate: startDate,
                            endDate: endDate,
                            key: 'selection',
                          });
                        }}
                        value={{
                          label: `${new moment(startDate).format(
                            'DD MMM'
                          )} - ${new moment(endDate).format('DD MMM')}`,
                        }}
                        options={dateRangeOptions}
                      />
                    </div>
                  </Stack>
                </Grid>

                <Grid item xs={12} sm={12} md={12} direction={'row'}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                      <CardDashboard
                        value={sentTotal}
                        icon={'bi:send'}
                        title={'Total Message Sent'}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <CardDashboard
                        value={deliveredTotal}
                        icon={'ant-design:message-outlined'}
                        title={'Total Message Delivered'}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <CardDashboard
                        value={showCost(
                          cost,
                          uiTotal,
                          biUtility,
                          biAuthentication,
                          biMarketing
                        )}
                        icon={'solar:money-bag-line-duotone'}
                        title={'Cost Estimate'}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <CardDashboard
                        value={uiTotal}
                        icon={'material-symbols:arrows-more-down-rounded'}
                        title={'Total User Initiated'}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <CardDashboard
                        value={biUtility}
                        icon={'material-symbols:arrows-more-up'}
                        title={'Total Business Utility'}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <CardDashboard
                        value={biMarketing}
                        icon={'material-symbols:arrows-more-up'}
                        title={'Total Business Marketing'}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <CardDashboard
                        value={biAuthentication}
                        icon={'material-symbols:arrows-more-up'}
                        title={'Total Business Authentication'}
                      />
                    </Grid>
                    {/* <Grid item xs={12} md={12}>
                      <TotalBalance value={0} />
                    </Grid> */}
                  </Grid>
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                  <MessagesChart
                    labels={labels}
                    values={values}
                    granularity={selectedDateFilter.granularity}
                  />
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                  <MessagesChart2
                    labels={conversationLabels}
                    values={conversationValues}
                    cost={cost}
                  />
                </Grid>
              </Grid>
            </Container>
          </Page>
        ) : (
          <Page title="Dashboard">
            <Container maxWidth="xl">
              <Box sx={{ marginTop: 5, marginBottom: 5, width: '100%' }}>
                <Tabs value={tab}>
                  <Tab
                    label="Conversation"
                    onClick={() => {
                      setTab(0);
                    }}
                  />
                  {!blacklistUser.some((item) => item === email) && (
                    <Tab
                      label="Broadcast"
                      onClick={() => {
                        setTab(1);
                      }}
                    />
                  )}
                </Tabs>
              </Box>
              <Box sx={{ pb: 5 }}>
                <Typography variant="h4">Broadcast</Typography>
              </Box>

              <Grid container spacing={3}>
                <Grid item md={4}>
                  <Stack
                    style={{
                      marginBottom: 20,
                    }}
                    direction="column"
                  >
                    <small>Select by Waba ID :</small>
                    <div style={{ width: '100%' }}>
                      <Select
                        onChange={(option) => {
                          setSelectedWabaId(option.value);
                          setSelectedWabaLabel(option.label);
                        }}
                        value={{
                          label: selectedWabaLabel,
                          value: selectedWabaId,
                        }}
                        options={wabaOptions}
                      />
                    </div>
                  </Stack>
                </Grid>

                <Grid item md={4}>
                  <Stack
                    style={{
                      marginBottom: 20,
                    }}
                    direction="column"
                  >
                    <small>Select time Range :</small>
                    <div style={{ width: '100%' }}>
                      <Select
                        onMenuOpen={() => {
                          setIsSelectingDate(true);
                          setDateRangeDate({
                            startDate: startDate,
                            endDate: endDate,
                            key: 'selection',
                          });
                        }}
                        value={{
                          label: `${new moment(startDate).format(
                            'DD MMM'
                          )} - ${new moment(endDate).format('DD MMM')}`,
                        }}
                        options={[]}
                      />
                    </div>
                  </Stack>
                </Grid>

                <Grid item md={4}>
                  <Stack
                    style={{
                      marginBottom: 20,
                    }}
                    direction="column"
                  >
                    <small>Select Phone Number :</small>
                    <div style={{ width: '100%' }}>
                      <Select
                        onChange={(option) => {
                          setSelectedPhoneNumber(option);
                        }}
                        value={selectedPhoneNumber}
                        options={phoneNumbers}
                      />
                    </div>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      <CardDashboard
                        value={broadcastSent}
                        icon={'bi:send'}
                        title={'Total Message Sent'}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <CardDashboard
                        value={broadcastDelivered}
                        icon={'ant-design:message-outlined'}
                        title={'Total Message Delivered'}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <CardDashboard
                        value={broadcastRead}
                        icon={'bi:send'}
                        title={'Total Message Read'}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                  <MessagesChartBroadcast
                    labels={broadcastLabels}
                    values={broadcastValues}
                  />
                </Grid>
              </Grid>
            </Container>
          </Page>
        )}
        <DateRangeSelectDialog
          open={isSelectingDate}
          onClose={() => {
            setIsSelectingDate(false);
          }}
          startDate={startDate}
          endDate={endDate}
          setStartDate={(value) => setStartDate(value)}
          setEndDate={(value) => setEndDate(value)}
        />
      </>
    );
  };

  return (
    <>
      {status?.status !== 'PENDING' ? (
        <DashboardNotPending />
      ) : (
        <PendingDashboard />
      )}
    </>
  );
}
